import { Form, Row, Col, Button, InputGroup } from "react-bootstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import Flatpickr from "react-flatpickr";
import {
  setActiveTab,
  setPaginationPageNumber,
  TriggerFilterButtonApi,
} from "../../../slices/common/reducer";
import {
  filterDateOptions,
  handleFilterDateChange,
} from "../../../Utils/CommonUtils";
import { setOrganizationFilterForm } from "../../../slices/org/organizationSlice";
import { ORG_FROM_DATE, ORG_TO_DATE } from "../../../Utils/FilterDateKeys";
import { CiSearch } from "react-icons/ci";

const OrganizationFilter = () => {
  const dispatch = useDispatch();

  const filterForm = useSelector((state) => state.organization.filter.form);

  const resetTabAndPageNumber = () => {
    dispatch(setPaginationPageNumber(0));
    dispatch(setActiveTab("ALL"));
  };

  const handleInputChange = (name, value) => {
    dispatch(setOrganizationFilterForm({ name, value }));
    resetTabAndPageNumber();
    dispatch(TriggerFilterButtonApi());
  };

  const handleClear = () => {
    dispatch(setOrganizationFilterForm({ type: "reset" }));

    dispatch(TriggerFilterButtonApi());

    if (Object.keys(filterForm).length > 0) {
      resetTabAndPageNumber();
    }
  };

  const organizationOptions = [
    { value: "ACTIVE", label: "Active" },
    { value: "INACTIVE", label: "Inactive" },
  ];

  const isClearButtonDisabled = !Object.values(filterForm).some(
    (value) => value
  );

  return (
    <div className="filter-wrapper">
      <Form className="form-input">
        <Row>
          <Form.Group as={Col} className="col-md-5">
            <InputGroup>
              <InputGroup.Text id="basic-addon1">
                {" "}
                <CiSearch />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search for Code, Name..."
                name="filter_ref"
                id="name"
                className="org-searchbar"
                value={filterForm.filter_ref || ""}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
              />
            </InputGroup>
          </Form.Group>
          <Form.Group as={Col} className="col-md-5">
            <Select
              isClearable
              placeholder="Status"
              name="status"
              options={organizationOptions}
              value={
                organizationOptions.find(
                  (itm) => itm.value === filterForm.status
                ) || null
              }
              onChange={(e) => handleInputChange("status", e ? e.value : "")}
            />
          </Form.Group>
          {/* <Form.Group as={Col} className="col-md-3">
            <Flatpickr
              className="form-control border-lightgrey"
              placeholder="Select date"
              data-input
              options={filterDateOptions}
              value={[
                filterForm[ORG_FROM_DATE]
                  ? new Date(filterForm[ORG_FROM_DATE])
                  : null,
                filterForm[ORG_TO_DATE]
                  ? new Date(filterForm[ORG_TO_DATE])
                  : null,
              ]}
              onChange={(e) =>
                handleFilterDateChange(
                  e,
                  setOrganizationFilterForm,
                  ORG_FROM_DATE,
                  ORG_TO_DATE
                )
              }
            />
          </Form.Group> */}
          <Form.Group as={Col} className="clear-btn">
            <Button
              className="primary-outline"
              onClick={handleClear}
              disabled={isClearButtonDisabled}
            >
              Clear
            </Button>
          </Form.Group>
        </Row>
      </Form>
    </div>
  );
};

export default OrganizationFilter;
